<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3 mt-2">
          <div class="vx-row">
            <router-link to="/inventory/goodsreceipt" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("inventory.label.Create Goods Receipt") }}</h3>
          </div>
        </ul>
      </div>
      <ValidationObserver ref="observer">
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("inventory.label.Purchase Date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Purchase Date')"
                  >
                    <Datepicker
                      :placeholder="$t('placeholder.label.SelectDate')"
                      v-model="good.purchaseDate"
                      class="font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.Purchase No')"
                >
                  <vs-input
                    :label="$t('inventory.label.Purchase No')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="good.purchaseNo"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.Supplier")
                    }}<span class="required"> *</span></small
                  >
                  <vue-simple-suggest
                    v-model="loc"
                    :list="getSuggestionList"
                    @input="testMethod2()"
                    class="w-full font-normal"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span
                        >{{ suggestion.supplierCode }} --
                        {{ suggestion.supplierDescription }}</span
                      >
                    </div>
                    <!-- Filter by input text to only show the matching results -->
                  </vue-simple-suggest>

                  <!-- <vs-input :label="$t('Office Id')" class="w-full mb-2 font-semibold" v-model="good.officeId" /> -->
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.Office Id")
                    }}<span class="required"> *</span></small
                  >
                  <vue-simple-suggest
                    v-model="loc1"
                    :list="getSuggestionList1"
                    @input="testMethod3()"
                    class="w-full font-normal"
                    :filter-by-query="true"
                  >
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                      <span
                        >{{ suggestion.name }} --
                        {{ suggestion.nameDecorated }}</span
                      >
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.Item Code")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.Item Code')"
                  >
                    <v-select
                      label="itemDescription"
                      v-model="itemMasterIdM"
                      :options="itemCodes.itemMasterData"
                      :reduce="(obj) => obj.id"
                      :placeholder="$t('inventory.label.SelectSearch')"
                      class="min-w-200 w-full font-semibold"
                    >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.Ordered Quantity')"
                >
                  <vs-input
                    :label="$t('inventory.label.Ordered Quantity')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="good.orderdQuantity"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <div class="saveCancelBtn mb-3">
            <vs-button type="border" class="" @click="backToGoods"
              >{{ $t("inventory.label.Reset") }}
            </vs-button>
            <vs-button class="" :disabled="!loc || !loc1" @click="createGRN">{{
              $t("inventory.label.Submit")
            }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import {
  getGrnTemplate,
  saveGoods,
  getGRNSupplierBySearch,
  getByIdGood,
  getBySupplerdropdown,
  getMrnSearch,
  getBySupplerId,
} from "@/http/inventory";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const goodEmptyObj = {
  commisionModel: "",
  externalId: "",
  id: "",
  name: "",
  nameDecorated: "",
  officeType: "",
  payment: "",
  subscriberDues: "",
  officeName: "",
  purchaseDate: moment().format("DD MMMM YYYY"),
  orderdQuantity: "",
  purchaseNo: "",
};

export default {
  data() {
    return {
      good: { ...goodEmptyObj },
      goods: {},
      items: {},
      id: "",
      loc: "",
      loc1: "",
      warningPopup: false,
      warningText: "",
      itemMasterId: "",
      itemMasterIdM: "",
      itemCodes: [],
      dropdown: [],
      supplierData: {},
      officeData: {},
      errorMessage: "",
      dateFormat: "dd MMMM YYYY",
      purchaseNo: "",
      itemCode: "",
      officeId: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    VueSimpleSuggest,
    moment,
    ValidationObserver,
    ValidationProvider,
  },
  computed: {},
  // mounted() {
  //     this.createContract()
  // },
  methods: {
    async getSuggestionList() {
      try {
        const response = await getGRNSupplierBySearch(this.loc);
        return response.data.supplierData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getSuggestionList1() {
      try {
        const response = await getMrnSearch(this.loc1);
        return response.data.officeData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getBySupplerdropdown() {
      try {
        const response = await getBySupplerdropdown(this.id);
        this.itemCodes = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async testMethod2() {
      let temp = this.loc;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc = temp.supplierCode + " -- " + temp.supplierDescription;
          this.good.name = temp.id;
          this.getBySupplerId(temp.id);
        }
      }
      this.getSuggestionList();
    },
    async changeCollection(e) {
      this.good.id = e.id;
      this.good.supplierDescription = e.supplierDescription;
      await this.getBySupplerId(this.good.id);
      setTimeout(() => {
        this.good.name = `${e.supplierCode} -- ${e.supplierDescription}`;
      });
    },
    testMethod3() {
      let temp = this.loc1;
      if (temp.includes("{")) {
        temp = JSON.parse(temp);

        if (typeof temp === "object") {
          this.loc1 = temp.name + " -- " + temp.nameDecorated;
          this.id = temp.id;
          //  this.getByIdGood(temp.id)
        }
      }
      this.getSuggestionList1();
    },
    // async changeCollection1(e) {
    //    this.good.id = e.id;
    //   this.good.nameDecorated = e.nameDecorated;
    //   await this.getByIdGood(this.good.id);
    //   setTimeout(() => {

    //     this.good.name = `${e.name} -- ${e.nameDecorated}`;
    //   });
    // },

    async getGrnTemplate() {
      try {
        const response = await getGrnTemplate();
        // this.good = response.data;
        // this.good.supplierData = this.good.supplierData.supplierCode;
      } catch (error) {
        throw Error(
          error.message ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getBySupplerId(id) {
      try {
    const response = await getBySupplerId(id);
    if (Array.isArray(response.data)) {
      this.itemCodes = { itemMasterData: response.data };
    } else {
      this.itemCodes = response.data;
    }
    this.itemMasterId = id;
  } catch (error) {
    console.error("Error loading supplier items:", error);
    throw Error(
      (error.message && error.message.errors && error.message.errors[0].defaultUserMessage) ||
        `Api failed with status code: ${error.message.httpStatusCode}`
    );
  }
    },

    async getByIdGood() {
      try {
        const response = await getByIdGood(this.id);
        let tempData = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async createGRN() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.goods.purchaseDate = moment(this.good.purchaseDate).format(
        "DD MMMM YYYY"
      );
      this.goods.dateFormat = this.dateFormat;
      this.goods.itemMasterId = this.itemMasterIdM;
      this.goods.officeId = this.id;
      this.goods.locale = "en";
      this.goods.orderdQuantity = this.good.orderdQuantity;
      // this.goods.purchaseDate = this.good.purchaseDate;
      this.goods.purchaseNo = this.good.purchaseNo;
      this.goods.supplierId = this.good.name;
      try {
        const resp = await saveGoods(this.goods);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Good Receipt Created Successfully!",
          type: "success",
        });
        if (resp.data.resourceId && resp.data.resourceId) {
          this.$router.push("/inventory/goodsreceipt");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    backToGoods() {
      this.good = { ...goodEmptyObj };
      this.loc = "";
      this.loc1 = "";
      this.itemMasterIdM = "";
      // this.$router.push(`/inventory/goodsreceipt`);
    },
    resetForm() {
      this.contract = contractEmptyObj;
      this.contract.subscriptionPeriod = "";
      this.contract.subscriptionType = "";
      this.contract.units = "";
      this.good = {
        purchaseDate: moment().format("DD MMMM YYYY"),
      };
    },
  },
  watch: {},
  created() {
    this.getGrnTemplate();
    this.getBySupplerdropdown();
    // this.id = this.$route.params.id;
    this.getByIdGood();
    this.getSuggestionList();
    // this.getBySupplerId(this.id);
  },
};
</script>
